import { Link } from "react-router-dom";
import { industries } from "@/data/industries";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function IndustriesPage() {
  return (
    <div data-testid="page-industries">
      <section className="py-20 md:py-28 hero-grid-bg">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-4">Industries</div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter text-[#1F1E4E] leading-[1.05]">
            One HR platform. Every industry.
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            ClockedIn HRM adapts to the way your industry works — with rules, roles, and reports built for real operations.
          </p>
        </div>
      </section>

      {industries.map((ind, i) => {
        const I = ind.icon;
        return (
          <section key={ind.slug} className={`py-16 ${i % 2 === 0 ? "bg-white" : "bg-[#F8FAFC]"}`}>
            <div className="max-w-7xl mx-auto px-6">
              <div className="grid lg:grid-cols-12 gap-10 items-start">
                <div className="lg:col-span-4">
                  <div className="h-12 w-12 rounded-xl bg-[#1F1E4E] flex items-center justify-center mb-5">
                    <I className="h-6 w-6 text-[#00A651]" />
                  </div>
                  <h2 className="text-3xl font-extrabold tracking-tight text-[#1F1E4E]">{ind.name}</h2>
                  <div className="mt-5 inline-flex items-center gap-2 bg-[#00A651]/10 text-[#00A651] text-xs font-bold rounded-full px-3 py-1">
                    ROI · {ind.roi}
                  </div>
                </div>
                <div className="lg:col-span-8 grid md:grid-cols-2 gap-5">
                  <div className="bg-white rounded-2xl border border-slate-200 p-6">
                    <div className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-3">The Challenge</div>
                    <p className="text-slate-700 leading-relaxed">{ind.challenge}</p>
                  </div>
                  <div className="bg-white rounded-2xl border border-slate-200 p-6">
                    <div className="text-xs font-bold uppercase tracking-widest text-[#00A651] mb-3">How We Solve It</div>
                    <p className="text-slate-700 leading-relaxed">{ind.solution}</p>
                  </div>
                  <div className="md:col-span-2 bg-[#1F1E4E] rounded-2xl p-6 text-white">
                    <div className="text-xs font-bold uppercase tracking-widest text-[#00A651] mb-3">Recommended Modules</div>
                    <div className="flex flex-wrap gap-2">
                      {ind.modules.map((m) => (
                        <span key={m} className="bg-white/10 rounded-full px-3 py-1.5 text-xs font-medium">{m}</span>
                      ))}
                    </div>
                    <Link to="/contact?intent=book_demo" data-testid={`industry-cta-${ind.slug}`} className="mt-5 inline-flex items-center gap-2 bg-[#00A651] hover:bg-[#008A43] text-white font-bold rounded-lg px-5 py-2.5 text-sm">
                      Book Demo for {ind.name} <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
